"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/favorite`;
    }
    /**
     * Returns the list of favorite contacts of the current extension.
   * Favorite contacts include both company contacts (extensions) and personal
   * contacts (address book records).
   *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/favorite
     * Rate Limit Group: Light
     * App Permission: ReadContacts
     * User Permission: ReadPersonalContacts
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the list of favorite contacts of the current extension.
   * Favorite contacts include both company contacts (extensions) and personal
   * contacts (address book records).**Please note**: Currently personal address
   * book size is limited to 10 000 contacts.
   *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/favorite
     * Rate Limit Group: Medium
     * App Permission: Contacts
     * User Permission: EditPersonalContacts
     */
    async put(favoriteCollection, restRequestConfig) {
        const r = await this.rc.put(this.path(), favoriteCollection, undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map